export default __webpack_public_path__ + "static/media/close.246af3da.svg";